export default __webpack_public_path__ + "static/media/Daftar Jenis Bantuan.65ac0c02.png";